import { render, staticRenderFns } from "./ManualChapter.vue?vue&type=template&id=40dc4301&scoped=true"
import script from "./ManualChapter.vue?vue&type=script&lang=js"
export * from "./ManualChapter.vue?vue&type=script&lang=js"
import style0 from "./ManualChapter.vue?vue&type=style&index=0&id=40dc4301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc4301",
  null
  
)

export default component.exports